import { h } from 'preact'
import Icon from '../../assets'

interface Props {
    count?: number,
    openModal: () => void
}
export const SetupIdeaStatusMappingWarning = ({ count, openModal }: Props) => {
  const countPrefix = count && count === 1 ? 'is' : 'are'
  const status = count && count === 1 ? 'status' : 'statuses'
  return (<div className='warning-box'>
    <Icon customClass='icon-warning' icon='warning' width={20} height={20} />
        There {countPrefix} {count} unmapped idea {status}, please <a onClick={() => openModal()}>update status mapping</a>.
  </div>
  )
}
